// set xwb/ajax as xwb.ajax
require('./ajax');